import React from "react";
import CategoryTitle from "./CategoryTitle";
import PostColumnContainer from "./PostColumnContainer";
import CardPanelWrapper from "./CardPanelWrapper";
import EditorPickCards from "./EditorPickCards";

const CategoryEditorPicks = ({ categoryName = null, marginTop, posts }) => {
  const catName = categoryName === "General" ? "Mode updates" : categoryName;
  return (
    <CardPanelWrapper marginTop={marginTop}>
      <CategoryTitle categoryName={`Editor’s picks in ${catName}`} />
      <PostColumnContainer>
        <EditorPickCards posts={posts} />
      </PostColumnContainer>
    </CardPanelWrapper>
  );
};

export default CategoryEditorPicks;
